import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFieldHalfVp = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={455}
        height={537}
        fill="none"
        viewBox="0 0 455 537"
        {...props}
    >
        <path fill="#2B632D" d="M0 0h454.668v77H0z" />
        <path fill="#367C38" d="M0 77h454.668v76H0z" />
        <path fill="#2B632D" d="M0 153h454.668v77H0z" />
        <path fill="#367C38" d="M0 230h454.668v77H0z" />
        <path fill="#2B632D" d="M0 307h454.668v77H0z" />
        <path fill="#367C38" d="M0 384h454.668v76H0z" />
        <path fill="#2B632D" d="M0 460h454.668v77H0z" />
        <path
            fill="#fff"
            d="M283.824 532.972c-.001-25.759-24.475-46.641-54.666-46.641s-54.663 20.882-54.663 46.641h-4.916c0-28.281 26.825-50.972 59.579-50.972 32.756 0 59.581 22.691 59.581 50.972z"
        />
        <path fill="#fff" d="M221 533.617c0-3.513 3.337-6.361 7.454-6.361s7.454 2.848 7.454 6.361z" />
        <path fill="#fff" d="M454.668 0v537H0V0zM4 533h446.668V4H4z" />
        <path
            fill="#fff"
            d="m4.33 13.364.64.013c6.754 0 12.25-4.146 12.42-9.309L17.39 4c-.001.03-.898-.485-1.891-.5l-2.111.5c-.059 1.096-.664 2.323-2.073 3.407-1.491 1.146-3.721 1.97-6.346 1.97q-.495 0-.97-.038L3.5 11.5l.5 1.848q.165.01.33.016M451.063 12.864l-.639.013c-6.754 0-12.25-4.146-12.42-9.309l-.001-.068c.001.03.898-.485 1.891-.5l2.111.5c.059 1.096.664 2.323 2.073 3.407 1.491 1.147 3.721 1.97 6.346 1.97q.495 0 .97-.038l.5 2.161-.5 1.848q-.165.01-.331.016M275.285 91.68c-9.131 14.834-27.24 24.803-47.93 24.803s-38.8-9.969-47.93-24.803l3.406-2.096c8.325 13.525 25.068 22.899 44.524 22.899s36.199-9.374 44.523-22.899z"
        />
        <path fill="#fff" d="M359.044 0v93.282H95.661V0zM99.661 89.282h255.383V4H99.661z" />
        <path fill="#fff" d="M286.989 0v33.92H167.721V0zM171.721 29.92h111.268V4H171.721z" />
        <path
            fill="#999"
            fillRule="evenodd"
            d="m299.608 392.11 13.724-76.959c1.097 0 2.15.022 3.195 0 6.952-.164 13.948.105 20.84-.627 6.436-.695 11.394-4.428 14.508-10.222 5.667-10.528-.097-20.877-12.029-21.31-8.311-.306-16.643-.03-24.961-.12-1.792-.022-2.076 1.001-2.308 2.315-2.912 16.815-5.794 33.63-8.728 50.43q-7.43 42.449-14.889 84.867c-.328 1.851-.679 3.696-1.038 5.645h-82.925c.657-3.906 1.269-7.691 1.934-11.469 1.568-8.804 3.121-17.607 4.764-26.395.306-1.673.851-3.323 1.516-4.883q33.122-77.61 66.259-155.188c.517-1.02.749-2.16.672-3.301-.523.829-1.075 1.636-1.546 2.479-19.473 34.661-38.916 69.336-58.397 103.989-17.494 31.106-35.018 62.198-52.505 93.304-.747 1.337-1.419 2.195-3.226 2.188-33.107-.067-66.215-.045-99.315-.052-.537 0-1.075-.053-1.963-.098L16 202.949h3.315c27.403 0 58.644.03 86.046-.075 0 0-.067-.164.389 2.143 7.242 35.781 14.634 72.853 21.974 108.611l8.99 43.784c.179.867.411 1.733.635 2.666h4.599c-.716-4.002-1.388-7.855-2.09-11.693-1.329-7.175-2.546-14.41-3.764-21.601a5.97 5.97 0 0 1 .486-3.763c21.593-39.35 43.254-78.647 64.863-117.996.859-1.568 1.844-2.113 3.614-2.113 50.826.044 101.667-.254 152.492.171 20.25.172 39.029 5.959 54.604 19.757 12.791 11.342 20.31 25.715 23.483 42.336 8.691 45.465-16.255 94.827-61.705 115.943-13.447 6.25-27.582 10.192-42.411 10.887-10.528.493-21.1.097-31.912.097z"
            clipRule="evenodd"
            style={{
                mixBlendMode: 'overlay',
            }}
        />
    </svg>
);
export default SvgFieldHalfVp;
